import * as React from 'react';
import { Controller } from 'react-hook-form';
import { Field } from './field';
export const findErrorForNestedField = (fieldName, obj) => {
    if (obj && obj.ref && obj.ref.name && obj.ref.name === fieldName) {
        return obj.message || obj.type || 'unknown';
    }
    for (const k in obj) {
        if (obj.hasOwnProperty(k)) {
            if (typeof obj[k] === 'object') {
                const found = findErrorForNestedField(fieldName, obj[k]);
                if (found) {
                    return found;
                }
            }
        }
    }
};
export const ReactHookFormField = (props) => (React.createElement(Controller, { name: props.name, render: ({ field, formState }) => (React.createElement(Field, Object.assign({}, field, props, { fieldError: findErrorForNestedField(props.name, formState.errors) }))), control: props.hooksFormControl, rules: { required: props.isRequired ? 'is required' : undefined } }));
//# sourceMappingURL=react-hook-form-field.js.map